import { ADVANCE_INDICATOR_INPUT_TYPE } from './advance-indicator-form.enums';
import { COMPARATORS } from '../../strategy.enums';

export const MATH_OPERATION_OPTIONS = [
    '+', '-', '*', '/'
];

export const MENU_OPTIONS = {
    [ADVANCE_INDICATOR_INPUT_TYPE.INDICATOR]: [],
    [ADVANCE_INDICATOR_INPUT_TYPE.MATH_OPERATION]: MATH_OPERATION_OPTIONS,
    [ADVANCE_INDICATOR_INPUT_TYPE.COMPARATOR]: Object.values(COMPARATORS),
    [ADVANCE_INDICATOR_INPUT_TYPE.SYMBOL]: [],
}